// extracted by mini-css-extract-plugin
export default {"container":"SmallScreenSection_container__D3KbW","testTwitch":"SmallScreenSection_testTwitch__yv5B8"};